import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OfflineWarning } from '../models/gms/offline-warning';

@Injectable({
  providedIn: 'root'
})
export class OfflineWarningService {
  private host = environment.apiUrl + '/v1/outage-notifications/offline-warnings';

  constructor(private httpClient: HttpClient) { }

  getAll(gmsId: string): Observable<OfflineWarning[]> {
    const url = this.host + `/${gmsId}`;
    return this.httpClient.get<OfflineWarning[]>(url);
  }

  delete(gmsId: string, id: number): Observable<void> {
    const url = this.host + `/${gmsId}/${id}`;
    return this.httpClient.delete<void>(url);
  }

  downloadAttachment(gmsId: string, attachment: string): Observable<HttpResponse<Blob>> {
    const url = `${this.host}/${gmsId}/download`;
    return this.httpClient.get(url, {
      params: { attachment },
      responseType: 'blob',
      observe: 'response',
    });
  }
}
